import React from 'react';
import Box from '@mui/material/Box';
import { withStyles } from 'tss-react/mui';
import CardActionArea from '@mui/material/CardActionArea';
import { CardContent, Card, Typography, Link } from '@mui/material';
import TunebatSvg from '../../misc/TunebatSvg';
import { isProduction } from '../../../utilities/environmentUtilities';
import { AnalyticsConstants, trackEvent } from '../../../utilities/analyticsUtilities';

const styles = (theme) => ({
    card: {
        marginTop: '50px',
        margin: "20px auto",
        [theme.breakpoints.down(450)]: {
            width: 'auto',
        }
    },
    svg: {
        width: '120px',
        height: '90px'
    },
    cardWrapper: {
        maxWidth: '400px',
        margin: '0 auto',
    }
});

const TunebatSongMasteringLink = ({ classes }) => {
    const songMasteringUrl = !isProduction()
        ? "https://adnsjd3b521ljd.tunebat.com/Song-Mastering"
        : "https://tunebat.com/Song-Mastering";

    const onSongMasteringLinkClick = () => {
        trackEvent('Clicked Song Mastering Link', {
            category: AnalyticsConstants.ECOMMERCE_CATEGORY,
        });
    }

    return (
        <div
            className={classes.cardWrapper}
        >
            <Link
                rel="noopener"
                target="_blank"
                underline='none'
                href={songMasteringUrl}
                onClick={onSongMasteringLinkClick}
            >
                <Card
                    className={classes.card}
                    variant="outlined"
                    row
                >
                    <CardActionArea>
                        <Box display="flex" justifyContent="space-around" alignItems="center">
                            <Box>
                                <TunebatSvg classes={classes.svg} />
                            </Box>
                            <Box textAlign="start" sx={{ display: 'flex', flexDirection: 'column' }}>
                                <CardContent>
                                    <Typography component="h6" variant='h6' >
                                        Tunebat Song Mastering
                                    </Typography>
                                    <Typography variant="body2">
                                        Make your music sound great on every speaker. Use Tunebat's simple audio mastering tool now.
                                    </Typography>
                                </CardContent>
                            </Box>
                        </Box>
                    </CardActionArea>
                </Card>
            </Link>
        </div>
    );
}

export default withStyles(TunebatSongMasteringLink, styles);